module.exports = __webpack_public_path__ + "static/media/leadfixed.2301a2c8.png";